import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, apiError, socialLogin } from "../../store/actions"
import { clearLocalCache } from "helpers/cache_helper";
// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo-sq.png"
import { setTimeCounter } from "store/products/actions"
import Loader from "components/Common/Loader"
import { changeSidebarType } from "../../store/actions"
import { leftSidebarTypes } from "../../constants/layout"

const Login = props => {
  const dispatch = useDispatch()
  const [rememberMeChecked, setRememberMeChecked] = useState(false)
  const [savedUserId, setSavedUserId] = useState('')
  const { error, loading } = useSelector(state => ({
    error: state.Login.error,
    loading: state.Login.loading,
  }))

  useEffect(() => {
      dispatch(changeSidebarType(leftSidebarTypes.ICON))
  }, [])

  useEffect(() => {
    if (localStorage.getItem("rememberMeKey")) {
      const obj = (localStorage.getItem("rememberMeKey"))
      setRememberMeChecked(true)
      setSavedUserId(obj)
    }
  }, [props.success])
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    clearLocalCache()
    //console.log('Val:'+JSON.stringify(values))
    if(rememberMeChecked){
      localStorage.setItem("rememberMeKey", (values.email))
    }
    else{
      localStorage.removeItem("rememberMeKey")
    }
    
    dispatch(setTimeCounter(1500000))
    dispatch(loginUser(values, props.history))
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | Flamingo</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <Loader showLoader={loading} />
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Flamingo.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="60"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          value={savedUserId}
                          errorMessage="Please enter a valid email"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          required
                          placeholder="Enter Password"
                          errorMessage="Please enter a password" 
                          validate={{
                            minLength: {value: 6, errorMessage: 'Minimum 6 characters please'},
                            maxLength: {value: 16, errorMessage: 'Your password must be between 6 and 16 characters'}
                          }}
                        />
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                          checked={rememberMeChecked}
                            onChange={() => {
                              setRememberMeChecked(!rememberMeChecked)
                            }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Flamingo {" "}
                  <i className="mdi mdi-heart text-danger" /> TekyMart
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
